import SearchBox from "../../../common_nextgen/common_components/SearchScreenComponents/SearchBox";

import DisplayTable from "../../../common_nextgen/common_components/SearchScreenComponents/DisplayTable";
import ButtonsSection from "../../../common_nextgen/common_components/SearchScreenComponents/ButtonsSection";
import NextGenPaginator from "../../../common_nextgen/common_components/Pagination/NextGenPaginator";
import ConfirmationModal from "../../../common_nextgen/common_components/Modal/ConfirmationModal";
import useGpiMscList from "./hooks/useGpiMscList.js";

const GpiMscList = ({
  onSelect,
  hideModal,
  params,
  lookupType,
  selectModeParamData = null,
}) => {
  const gpiMscListData = useGpiMscList(
    onSelect,
    hideModal,
    params,
    lookupType,
    selectModeParamData
  );

  return (
    <div class="container container-fluid popup">
      <ButtonsSection ctaButtons={gpiMscListData.leftButtons} align="left" />
      <div className="header-section">
        <h1>
          {gpiMscListData.screen_title} -{" "}
          <span className="heading-cod">{gpiMscListData.screenNumber}</span>
        </h1>
      </div>
      <SearchBox
        formFields={gpiMscListData.formFields}
        dropdownValues={gpiMscListData.dropdownValues}
        paramsData={gpiMscListData.paramsData}
        updataParamData={gpiMscListData.updateParamData}
      />
      <ButtonsSection ctaButtons={gpiMscListData.ctaButtons} />
      <DisplayTable
        data={gpiMscListData.data}
        parmKey={gpiMscListData.parmKey}
        menuOptions={gpiMscListData.menuOptions}
        tableHeaders={gpiMscListData.columnDef}
        setRowData={gpiMscListData.setRowData}
        selectedPriceSchedules={gpiMscListData.selectedRows}
        setSelectedPriceSchedules={gpiMscListData.setSelectedRows}
        selectMode={true}
      />
      <div className="paginator-container">
        <NextGenPaginator
          first={gpiMscListData.first}
          rows={gpiMscListData.rows}
          totalRecords={gpiMscListData.totalRecords}
          currentPage={gpiMscListData.currentPage}
          rowsPerPageOptions={[10, 25, 50]}
          onPageChange={gpiMscListData.onPageChange}
        />
      </div>
      {gpiMscListData.isConfirmationModalOpen && (
        <ConfirmationModal
          isOpen={gpiMscListData.isConfirmationModalOpen}
          onRequestClose={gpiMscListData.closeConfirmationModal}
          onBack={gpiMscListData.closeConfirmationModal}
          onSave={gpiMscListData.deletePriceSchedule}
          confirmLabel="Confirm(Y/N)"
          options={[
            { label: "N-No", value: "no" },
            { label: "Y-Yes", value: "yes" },
          ]}
          setSelectedOption={gpiMscListData.setSelectedOption}
        />
      )}
      {gpiMscListData.isHideConfirmationModalOpen && (
        <ConfirmationModal
          isOpen={gpiMscListData.isHideConfirmationModalOpen}
          onRequestClose={gpiMscListData.closeHideConfirmationModal}
          onBack={gpiMscListData.closeHideConfirmationModal}
          onSave={gpiMscListData.hidePriceSchedule}
          confirmLabel="Confirm(Y/N)"
          options={[
            { label: "N-No", value: "no" },
            { label: "Y-Yes", value: "yes" },
          ]}
          setSelectedOption={gpiMscListData.setHideSelectedOption}
        />
      )}
    </div>
  );
};

export default GpiMscList;
